import {ADD_ITEMS, SWITCH_PAGE} from './type'
import {DIRECTION} from './storeEnum'
import {WMS3Constants} from '@/api/biz/bizEnum'

const preNextPage = {
  state: {
    items: [
      {
        routeName: 'maintainArea', //路由名称
        yesOrNo: 1, //开仓选项，1-是;0-否;
      },
      {
        routeName: 'maintainZone', //路由名称
        yesOrNo: 1, //开仓选项，1-是;0-否;
      }
    ], // 用于存放上一页、下一页路由信息的数组
    cursor: 1 // 游标，用于记录当前页面路由的位置
  },
  getters: {
    cursor: state => state.cursor
  },
  mutations: {
    // 添加
    [ADD_ITEMS](state, items) {
      state.items = [];
      let size = items.size;
      for (let i = 0; i < size; i++) {
        state.items.push(items[i]);
      }
    },
    // 切换页面
    [SWITCH_PAGE](state, payload) {
      let _this = payload.this
      let direction = payload.direction;
      let index = state.cursor;
      let size = state.items.length
      if (direction === DIRECTION.PRE) {
        index -= 1
        if (index < 0) {
          index = 0
        }
        for (let i = index; i >= 0; i--) {
          let item = state.items[i];
          if (item.yesOrNo === WMS3Constants.NO) {
            state.cursor = i;
            _this.$router.push({ name: item.routeName, params: {..._this.$route.params, isShow: true} })
            return
          }
        }
      }
      if (direction === DIRECTION.NEXT) {
        index += 1
        if (index >= size) {
          index = size - 1
        }
        for (let i = index; i < size; i++) {
          let item = state.items[i];
          if (item.yesOrNo === WMS3Constants.YES) {
            state.cursor = i;
            _this.$router.push({ name: item.routeName, params: {..._this.$route.params, isShow: true} })
            return
          }
        }
      }
    }
  }
}

export default preNextPage
